import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Shield, Landmark } from 'lucide-react';
import { NotaryProfileForm, useNotaryProfile } from '../components/labor/NotaryProfileForm';
import { NotaryLogo } from '../components/labor/NotaryLogo';
import { AccountPlanSummary } from '../components/fidem/AccountPlanSummary';
import { GoogleAccountLink } from '../components/auth/GoogleAccountLink';

export default function ProfilePage() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [profile, setProfile, loaded] = useNotaryProfile();

  return (
    <div data-testid="profile-page" className="min-h-screen bg-slate-950 text-white">
      <header className="border-b border-slate-800">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 h-16 flex items-center gap-3">
          <button data-testid="profile-back-btn" onClick={() => navigate('/dashboard')}><Shield className="w-8 h-8 text-blue-500" /></button>
          <span className="text-xl font-bold">Mi Perfil</span>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 sm:px-6 py-10 space-y-8">
        <section>
          <p className="text-sm text-slate-400">Cuenta</p>
          <p data-testid="profile-email" className="text-lg font-semibold">{user?.full_name || user?.username || user?.email}</p>
          <p className="text-sm text-slate-500">{user?.email}</p>
        </section>
        <AccountPlanSummary testid="profile-plan" />
        <GoogleAccountLink />
        <section className="bg-slate-900 border border-slate-800 rounded-2xl p-6 space-y-4">
          <div>
            <h2 className="text-lg font-semibold flex items-center gap-2"><Landmark className="w-5 h-5 text-amber-400" />Datos de la notaría</h2>
            <p className="text-sm text-slate-400">Se completan solos en cada hoja de ratificación y en el envío a FirmaWeb.</p>
          </div>
          <NotaryProfileForm profile={profile} setProfile={setProfile} loaded={loaded} />
        </section>
        <NotaryLogo hasName={!!profile.notary_name} />
      </main>
    </div>
  );
}
